import React from 'react';
import { IconStar, IconStarFilled } from '@mindly/ui-components';

type StarRatingProps = {
  onSelect: (rating: number) => void;
  selected: number | null;
};

export const StarRating: React.FC<StarRatingProps> = ({ onSelect, selected }) => {
  const starStyle = {
    cursor: 'pointer',
    padding: '0 6px',
    width: 50,
    height: 50,
    aspectRatio: '1 / 1',
    transition: 'color 0.2s ease-in-out',
  };

  return (
    <div className="flex items-center justify-center">
      {[1, 2, 3, 4, 5].map((n) => {
        const isSelected = selected && n <= selected;

        return isSelected ? (
          <IconStarFilled
            key={n}
            onClick={() => onSelect(n)}
            style={{
              ...starStyle,
              color: '#000',
            }}
          />
        ) : (
          <IconStar
            key={n}
            onClick={() => onSelect(n)}
            style={{
              ...starStyle,
              color: '#666',
            }}
          />
        );
      })}
    </div>
  );
};
